import {
  Box,
  Button,
  Grid,
  IconButton,
  Menu,
  MenuItem,
  Skeleton,
  Tooltip,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import DataTable from "../../../components/DataTable/DataTable";
import { EditIcon, FilterIcon, MoreIcon } from "../../../assets/icons/Icons";
import StatusGenerator from "../../../components/TransactionLog/StatusGenerator";
import SearchBox from "../../../components/Test/SearchBox";
import FilterButton from "../../../components/TransactionLog/FilterButton";
import { useDispatch } from "react-redux";
import {
  getAllTransactions,
  getTransactionById,
} from "../../../redux/payment/paymentActions";
import usePayment from "../../../hooks/usePayment";
import { ReactComponent as MoneyBagGreen } from "../../../assets/images/moneyBagGreen.svg";
import { ReactComponent as MoneyBagRed } from "../../../assets/images/moneyBagRed.svg";
import VisibilityIcon from "@mui/icons-material/Visibility";

import ReplayIcon from "@mui/icons-material/Replay";
import RefreshIcon from "@mui/icons-material/Refresh";
import ViewTransactionDialog from "../../../components/TransactionLog/ViewTransactionDialog";
import { formatDate } from "../../../helpers/helper";
import TransactionStatusDialog from "../../../components/TransactionLog/TransactionStatusDialog";
import Filter from "../../../components/TransactionLog/Filter";
import EnrollOfflinePayment from "../../../components/OfflinePayment/EnrolOfflinePayment";
import CustomizedDialogs from "../../../components/StudentManagement/Dialog";
import { useNotifications } from "../../../components/notifications/notifications";
import SingleOfflinePaymentForm from "../../../components/OfflinePayment/SingleOfflinePayment";
import useOfflinePayment from "../../../hooks/useOfflinePayment";
import { GetOfflinePayment } from "../../../redux/offlinePayment/offlinePaymentActions";

const OfflinePayment = () => {
  const [transactionData, setTransactionData] = useState([]);
  const [formattedData, setFormattedData] = useState([]);
  const offlinePayment= useOfflinePayment()
  const {getOfflinePayment}= offlinePayment;
  const dispatch=useDispatch()
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [openSinglePayment, setOpenSinglePayment] = React.useState(false);
  const [open, setOpen] = React.useState(false);
  const [increaseModalSize, setIncreaseModalSize] = useState(false);
  const [ToastState, setToastState] = useNotifications();

    const handleOpenModal = () => {
      setOpen(true);
      setIncreaseModalSize(true);
    }

    useEffect(()=>{
    dispatch(GetOfflinePayment())
    }, [])
    const handleSinglePayment = ()=>{
        setOpenSinglePayment(true);
        // setIncreaseModalSize(false);
    }
    const handleClose = () =>{
        setOpen(false);
      setIncreaseModalSize(false);
      setOpenSinglePayment(false);
    }
   const ColumnTextStyle = {
    textTransform: "capitalize",
    textAlign: "left",
    color: "#212b36",
    fontSize: "0.875rem",
    fontWeight: 600,
  };



  const columns = [
    {
      name: "S/N",
      label: "S/N",
      options: {
        setCellProps: () => ({ style: { padding: "20px" } }),
        customHeadLabelRender: ({ index, ...column }) => {
          return (
            <Typography sx={ColumnTextStyle} key={index}>
              {column.label}
            </Typography>
          );
        },
        customBodyRender: (value, tableMeta) => {
          return <span>{tableMeta.rowIndex + 1} </span>;
        },
      },
    },
    {
      name: "FullName",
      label: "Name",
      options: {
        // setCellProps: () => ({ style: { minWidth: "200px" } }),
        customHeadLabelRender: ({ index, ...column }) => {
          return (
            <Typography sx={ColumnTextStyle} key={index}>
              {column.label}
            </Typography>
          );
        },
        customBodyRender: (value, tableMeta) => {
          const email = tableMeta.rowData[2];
          return (
            <Box>
              <Typography fontSize={"14px"} fontWeight={500}>
                {value}
              </Typography>
              <Typography fontSize={"12px"}>{email}</Typography>
            </Box>
          );
        },
      },
    },
    {
      name: "Email",
      label: "Email",
      options: {
        display: false,
        setCellProps: () => ({ style: { minWidth: "180px", padding: "20px" } }),
      },
    },
    {
      name: "Currency",
      label: "Currency",
      options: {
        display: false,
        setCellProps: () => ({ style: { minWidth: "180px", padding: "20px" } }),
      },
    },
    {
      name: "CategoryName",
      label: "User Type",
      options: {
        // setCellProps: () => ({ style: { minWidth: "100px" } }),
        customHeadLabelRender: ({ index, ...column }) => {
          return (
            <Typography sx={ColumnTextStyle} key={index}>
              {column.label}
            </Typography>
          );
        },
      },
    },
    {
      name: "Name",
      label: "Plan",
      options: {
        // setCellProps: () => ({ style: { minWidth: "100px" } }),
        customHeadLabelRender: ({ index, ...column }) => {
          return (
            <Typography sx={ColumnTextStyle} key={index}>
              {column.label}
            </Typography>
          );
        },
      },
    },
    {
      name: "Slots",
      label: "License",
      options: {
        // setCellProps: () => ({ style: { minWidth: "100px" } }),
        customHeadLabelRender: ({ index, ...column }) => {
          return (
            <Typography sx={ColumnTextStyle} key={index}>
              {column.label}
            </Typography>
          );
        },
      },
    },
    {
      name: "Trans_Amt",
      label: "Amount",
      options: {
        // setCellProps: () => ({ style: { minWidth: "130px" } }),
        customHeadLabelRender: ({ index, ...column }) => {
          return (
            <Typography sx={ColumnTextStyle} key={index}>
              {column.label}
            </Typography>
          );
        },
        customBodyRender: (value, tableMeta) => {
          let formattedNumber = new Intl.NumberFormat().format(value);
          const currency = tableMeta.rowData[3];
          return currency == 566
            ? `₦${formattedNumber}`
            : `$${formattedNumber}`;
        },
      },
    },
    {
      name: "UPTransId",
      label: "Transaction Id",

      options: {
        display: false,
        // setCellProps: () => ({ style: { minWidth: "150px" } }),
        customHeadLabelRender: ({ index, ...column }) => {
          return (
            <Typography sx={ColumnTextStyle} key={index}>
              {column.label}
            </Typography>
          );
        },
      },
    },

    {
      name: "trans_Date",
      label: "Date & Time",
      options: {
        // setCellProps: () => ({ style: { minWidth: "180px" } }),
        customHeadLabelRender: ({ index, ...column }) => {
          return (
            <Typography sx={ColumnTextStyle} key={index}>
              {column.label}
            </Typography>
          );
        },
        customBodyRender: (value, tableMeta) => {
          return value ? formatDate(value) : "";
        },
      },
    },
    {
      name: "UPStatus",
      label: "Transaction Status",
      options: {
        // sort: false,
        customHeadLabelRender: ({ index, ...column }) => {
          return (
            <Typography sx={ColumnTextStyle} key={index}>
              {column.label}
            </Typography>
          );
        },
        customBodyRender: (value, tableMeta) => {
          const lowerCaseValue =
            typeof value === "string" ? value?.toLowerCase() : value;
          switch (lowerCaseValue) {
            case "approved":
              return (
                <StatusGenerator statusText="Approved" variant="greenFilled" />
              );
            case "declined":
              return (
                <StatusGenerator statusText="Declined" variant="redFilled" />
              );
            case "initiated":
              return (
                <StatusGenerator
                  statusText="Initiated"
                  variant="yellowFilled"
                />
              );
            default:
              return "no status";
          }
        },
        // filter: true,
      },
    },
    // {
    //   name: "action",
    //   label: "Action",
    //   options: {
    //     customBodyRender: (value, tableMeta) => {
    //       // const rowData = payment.transactions.allTransData[tableMeta.rowIndex];
    //       const id = value?.UPTransId;
    //       const queryData = value?.UPStatus?.toLowerCase() === "initiated";
    //       return (
    //         <>
    //           <Tooltip title={"More"}>
    //             <IconButton
    //               size="small"
    //               onClick={(event) => handleClick(event, id, queryData)}
    //             >
    //               <MoreIcon color="#40499D" />
    //             </IconButton>
    //           </Tooltip>
    //         </>
    //       );
    //     },
    //   },
    // },
  ];

  const modalContent = {
    title: "Offline Payment",
    content: (
        <SingleOfflinePaymentForm
        openSinglePayment={openSinglePayment}
        handleSinglePayment={handleSinglePayment}
        setOpenSinglePayment={setOpenSinglePayment}
        closeModal={handleClose}
        setToastState={setToastState}
       />
    ),
  };
 

  return (
    <>
    <div className="flex justify-between">
            <div className="flex gap-1">
            <Typography variant="h6" fontWeight={"bold"} pb={2}>
        Offline Payment
      </Typography>
            </div>
     
      <Box mb={2}>
        <Button
          variant="contained"
          color="primary"
         onClick={handleSinglePayment}
        >
          Add Payment
        </Button>
      </Box>
      </div>


      <Box sx={{ width: "100%", overflowX: "auto" }}>
        <DataTable
           data={getOfflinePayment}
          columns={columns}
          topMargin={true}
          tableName={"Transactions"}
          // download={true}
          search={true}
          serverSide={false}
          // loading={payment?.loading}
          formatData={formattedData}
          fileName={"Offline Payment"}
        />
      </Box>
      
      

   <CustomizedDialogs
        open={openSinglePayment}
        handleClose={handleClose}
        content={modalContent}
        width={"900px"}
        maxWidth={increaseModalSize ? "md" : "sm"}
      />
        <ToastState />
        </>
  );
};

export default OfflinePayment;
